import { forwardRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Iconify from './Iconify';

const INDIGO = 'var(--color-primary-main)';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: 18,
    boxShadow: '0 20px 60px rgba(15,23,42,0.15)',
    border: '1px solid #E2E8F0',
    overflow: 'hidden',
  },
}));

const Transition = forwardRef((props, ref) => {
  const theme   = useTheme();
  const fullScr = useMediaQuery(theme.breakpoints.down('md'));
  if (!fullScr) return <Fade in ref={ref} {...props} />;
  return <Slide direction="up" ref={ref} {...props} />;
});

function PopUpDialog({ openPopup, closePopup, title, children, maxWidth = 'md', fullWidth = false }) {
  const theme   = useTheme();
  const fullScr = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledDialog open={openPopup} maxWidth={maxWidth} fullWidth={fullWidth}
      fullScreen={fullScr} TransitionComponent={Transition}>
      <DialogTitle sx={{ p: 0 }}>
        {/* Vibrant gradient strip */}
        <Box sx={{
          height: 4,
          background: `linear-gradient(90deg, ${INDIGO}, #818CF8, #0EA5E9)`,
        }} />
        <Stack direction="row" alignItems="center" justifyContent="space-between"
          sx={{ px: 3, py: 2 }}>
          <Typography variant="h5" sx={{
            color: '#0F172A', fontWeight: 800, letterSpacing: '-0.01em',
          }}>
            {title}
          </Typography>
          <IconButton onClick={closePopup} size="small" sx={{
            color: '#94A3B8', borderRadius: '8px', transition: 'all 0.15s',
            '&:hover': { background: 'rgba(var(--color-primary-main-rgb), 0.08)', color: INDIGO },
          }}>
            <Iconify icon="ep:close-bold" width={18} height={18} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider sx={{ borderColor: '#E2E8F0' }} />
      <DialogContent sx={{ px: 3, py: 2.5 }}>{children}</DialogContent>
    </StyledDialog>
  );
}

export default PopUpDialog;
